import { z } from "zod";
import { phonePattern } from "./shared";

export const CONTACT_MESSAGE_MAX_LENGTH = 1000;

// Limits match ContactUsRequest in the API (name 2-100, message up to 1000).
export const contactSchema = z.object({
  name: z.string().trim().min(2, "Enter your name").max(100, "Use 100 characters or fewer"),
  email: z.string().trim().pipe(z.email("A valid email is required")),
  phone: z
    .string()
    .transform((value) => value.replace(/\s+/g, ""))
    .refine((value) => !value || phonePattern.test(value), "Enter a valid phone number, or leave this blank"),
  message: z
    .string()
    .trim()
    .min(10, "Tell us a little more, at least 10 characters")
    .max(CONTACT_MESSAGE_MAX_LENGTH, "Keep your message under 1,000 characters"),
});

export type ContactFormData = z.infer<typeof contactSchema>;
